import { DATA_BLOCK_THEME } from './modules/dataBlock';
import { RADAR_TARGET_THEME } from './modules/radarTarget';
import { SCOPE_THEME } from './modules/scope';
import { TERRAIN_THEME } from './modules/terrain';
import { WIND_VANE_THEME } from './modules/windVane';

/**
 * @enum THEME_DEFAULT
 * @type {Object}
 * @final
 */
export const THEME_DEFAULT = {
    CLASSNAME: 'canvas-theme-default',
    DATA_BLOCK: DATA_BLOCK_THEME,
    RADAR_TARGET: RADAR_TARGET_THEME,
    SCOPE: SCOPE_THEME,
    TERRAIN: TERRAIN_THEME,
    WIND_VANE: WIND_VANE_THEME
};
